import { render, staticRenderFns } from "./SchoolWiseStatus.vue?vue&type=template&id=53feac22&scoped=true&"
import script from "./SchoolWiseStatus.vue?vue&type=script&lang=js&"
export * from "./SchoolWiseStatus.vue?vue&type=script&lang=js&"
import style0 from "./SchoolWiseStatus.vue?vue&type=style&index=0&id=53feac22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53feac22",
  null
  
)

export default component.exports